export default "__VITE_ASSET__DbAd7jsS__"